<template>

<app-content :loading="is.loading">

	<app-content-body v-if="!is.loading" :is-call="true">

		<app-content-call :loading="is.confirming" icon="cancel" theme="red" title="Retract Pre-approval" :text="text" :has-cancel="true" button="Confirm" v-on:click="onConfirmClick" v-on:cancel="onCancelClick">
        
            <app-content-alert v-if="item.count.assignments" :is-inline="true" icon="warning" theme="yellow" :is-slim="true" title="This volunteer has already been assigned to one or more slots. Unlock any of the below assignments that you also want to cancel, otherwise any locked assignments will be preserved despite the retraction." class="warning" />

            <app-table v-if="item.count.assignments">

                <app-table-head :layout="layout">

                    <app-table-column />

                    <app-table-column text="Role" /> 

                    <app-table-column text="Slot" />

                <app-table-column />

                </app-table-head>

                <app-table-body>

                    <app-table-row :layout="layout" v-tooltip="'Click to toggle lock'" v-for="assignment in assignments" :key="assignment.id" v-on:click="onLockClick(assignment.id)">

                        <app-table-cell-label :text="$constants.volunteers.assignment.statusName[assignment.status]" :type="$constants.volunteers.assignment.statusTheme[assignment.status]" :subtext="assignment.reference" />
                    
                        <app-table-cell-text :text="assignment.role.name" />
                        
                        <app-table-cell-text :text="assignment.slot.name" />

                        <app-table-cell-icon align="center" icon="locked" theme="green" v-if="!$_.contains(model.unlocked, assignment.id)" />
                        <app-table-cell-icon align="center" icon="unlocked" theme="red" v-if="$_.contains(model.unlocked, assignment.id)" />

                    </app-table-row>

                </app-table-body>

            </app-table>

		</app-content-call>
	
	</app-content-body>

</app-content>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
            layout: '100px 1fr 1fr 40px',
			model: {
                unlocked: []
            },
			item: {},
            assignments: []
		}

	},

	created: function() {

		this.load();

	},

	computed: {

		text: function() {
		
			return 'The pre-approval will be retracted and the badge holder will no longer be able to access the volunteers section.'
		
		}

	},

	methods: {

        onLockClick: function(id) {

            this.$util.array.toggle(this.model.unlocked, id)
        
        },

		onCancelClick: function() {

			this.$router.push({
				name: 'Convention.Volunteers.Approvals.Edit'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.post('convention/volunteers/approval/' + this.$route.params.id + '/retract', this.model).then(function() {

				this.$notify({
					message: 'The approval has been retracted!'
				})

				this.$router.push({
					name: 'Convention.Volunteers.Approvals'
				})

			}.bind(this))

		},

		load: function() {

			this.$api.get('convention/volunteers/approval/' + this.$route.params.id + '/retract').then(function(response) {

				Vue.set(this, 'item', response.item)
				Vue.set(this, 'assignments', response.assignments)
				
				this.is.loading = false

			}.bind(this), function() {
			
				this.$notify({
					message: 'This is not a valid approval.',
					type: 'error'
				})

				this.$router.push({
					name: 'Convention.Volunteers.Approvals.Edit'
				})
			
			}.bind(this))

		}

	}

}

</script>

<style scoped>

.warning {
    margin-top: 20px;
}

</style>
